<template>
    <div>
        <KSKC v-if="$vuetify.breakpoint.xsOnly" />
        <LabeledCard v-if="$vuetify.breakpoint.smAndUp" :label="$t('Общая информация по КСК/ОСИ/ПТ')" class="pt-10">
            <KSKC />
        </LabeledCard>
    </div>
</template>

<script>
import KSKC from '@/components/KSKC.vue';
import LabeledCard from '@/components/ui/LabeledCard';

export default {
    name: 'Contracts',
    components: {
        KSKC,
        LabeledCard
    },
    computed: {},
    methods: {}
};
</script>
